export default "__VITE_ASSET__Ds5hWUQq__"